import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchDataSecurityApplicationsRequest = {
	applicationIds: number[];
	ownerId?: number;
	stakeholderIds?: number[];
	stakeholderGroupId?: number;
	classification?: string | null;
};

export const patchDataSecurityApplications = createPatchEndpoint<PatchDataSecurityApplicationsRequest>(
	'/api/v3/data-security/applications/'
);
